import produce from 'immer';
import { ActionsUnion, createAction } from 'utils/actionHelpers';

export enum ActionTypes {
  TOGGLE_BLOCKING_UI = 'TOGGLE_BLOCKING_UI',
  TOGGLE_SIDEBAR_PANEL = 'TOGGLE_SIDEBAR_PANEL',
  HIDE_SIDEBAR = 'HIDE_SIDEBAR',

  TIPS_SAVE = 'TIPS_SAVE',
}

export const initialState = {
  isUIBlocked: false,
  activePanelId: undefined,
  tips: {},
};

export const Actions = {
  toggleUIBlocking: (payload: boolean) =>
    createAction(ActionTypes.TOGGLE_BLOCKING_UI, payload),

  toggleSidebarPanel: (payload?: number) =>
    createAction(ActionTypes.TOGGLE_SIDEBAR_PANEL, payload),

  hideSidebar: () =>
    createAction(ActionTypes.HIDE_SIDEBAR),

  tipsSave: (payload: any) =>
    createAction(ActionTypes.TIPS_SAVE, payload),
};

export interface IAppState {
  isUIBlocked: boolean;
  activePanelId?: number;
  tips: { [key: string]: string };
}

export type AppAction = ActionsUnion<typeof Actions>;

export default (state: IAppState = initialState, action: AppAction) =>
  produce(state, (draft: IAppState) => {
    switch (action.type) {
      case ActionTypes.TOGGLE_BLOCKING_UI:
        draft.isUIBlocked = action.payload;
        return;
      case ActionTypes.TOGGLE_SIDEBAR_PANEL:
        draft.activePanelId = draft.activePanelId === action.payload ? undefined : action.payload;
        return;
      case ActionTypes.HIDE_SIDEBAR:
        draft.activePanelId = undefined;
        return;

      case ActionTypes.TIPS_SAVE:
        draft.tips = action.payload;
        return;
    }
  });
